import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import NotFound from "./pages/NotFound";
import Live from "./pages/Live";
import Album from "./pages/Album";
import PhoneForm from "./pages/PhoneForm";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="App">
      <div className="container">
        <div className="title">NOTHING IS EVER WRONG</div>
        <div className="text">
          <Link to="/album">OUT NOW</Link>
        </div>
        <div className="links">
          <a href="https://www.instagram.com/e.verbound/">IG</a>
          <a href="https://x.com/everboundd">X</a>
          <a href="https://www.youtube.com/@e.verbound">YT</a>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/album" element={<Album />} />
        <Route path="/live" element={<Live />} />
        <Route path="/live/rsvp" element={<PhoneForm />} />
      </Routes>
    </Router>
  );
}

export default App;
